document.addEventListener('DOMContentLoaded', async function () {

	function setBackGroundImage(element, headerImg) {
		const backgroundImage = element.querySelector('.job_detail__background-section');
		if (backgroundImage) {
			let src = backgroundImage.getAttribute('data-image-' + headerImg)
			if (!src) {
				src = backgroundImage.getAttribute('data-image-standard')
			}
			backgroundImage.style.backgroundImage = `url('${src}')`;
		}
	}

	const setTextContent = (selector, text, el) => {
		const element = el.querySelector(selector);
		if (element) {
			element.innerText = text;
		}
	};

	const setDescription = (selector, text, el) => {
		const element = el.querySelector(selector);
		if (element) {
			element.innerHTML = text;
		}
	};

	async function fetchJob(element, idToFind, url) {
		try {
			// Fetch XML data
			const response = await fetch(url);
			const xmlText = await response.text();

			// Parse XML
			const parser = new DOMParser();
			const xmlDoc = parser.parseFromString(xmlText, 'application/xml');

			const job = Array.from(xmlDoc.querySelectorAll('job'))
				.find(job => job.querySelector('id').textContent == idToFind);

			if (job) {
				const name = job.querySelector('name')?.textContent ?? "";
				const location = job.querySelector('location')?.textContent ?? "";
				const jobIntroText = job.querySelector('cfJob_introText')?.textContent ?? "";
				const jobTeaserText = job.querySelector('cfJob_TeaserText')?.textContent ?? "";
				const companyDescription = job.querySelector('companyDescription')?.textContent;

				const description = job.querySelector('description')?.textContent ?? "";
				const requirements = job.querySelector('requirements')?.textContent ?? "";
				const applyUrl = job.querySelector('applyUrl')?.textContent;
				const headerImg = job.querySelector('headerImg')?.textContent.trim().toLowerCase();


				setTextContent('.job-name-js', name,  element);
				setTextContent('.job-location-js', location, element);
				setTextContent('.job-intro-text-js', jobIntroText, element);
				setDescription('.job-teaser-text-js', jobTeaserText, element);
				setDescription('.job-company-description-js', companyDescription, element);
				setDescription('.job-description-js', requirements, element);
				setDescription('.job-requirements-js', description, element);


				const applyURL = element.querySelector('.apply-button-js');
				if (applyURL) {
					applyURL.href = applyUrl;
				}
				setBackGroundImage(element, headerImg);

				const showSpinner = document.querySelector('.job_detail__show');
				const jobPage = document.querySelector('.job_detail__display');
				showSpinner.style.display = 'none';
				jobPage.style.display = "block";
			} else {
				window.location = "/";
			}
		} catch (error) {
			console.error('Error fetching or parsing XML:', error);
		}
	}

	let jobWidgetSourceURLs = document.querySelectorAll(".single-job-widget-source-url");
	if (jobWidgetSourceURLs.length > 0) {
		for (const jobWidgetSourceURL of jobWidgetSourceURLs) {
			let url = new URL(window.location.href);
			let jobID = url.searchParams.get('id');
			if (jobID) {
				const sourceURL = jobWidgetSourceURL.getAttribute("data-source-url");
				if (sourceURL){
					await fetchJob(jobWidgetSourceURL, jobID, sourceURL);
				}
			}else{
				console.log('ID is require')
			}
		}
	}
});
